import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startSpinner, finishSpinner } from "../ui/spinner";
const urlBase= process.env.REACT_APP_URL

const configuracionPorCategoriaTraerStart = () => ({
  type: types.configuracionPorCategoriaTraerStart,
});
export const configuracionPorCategoriaTraerError = (error) => ({
  type: types.configuracionPorCategoriaTraerError,
  payload: error,
});
export const configuracionPorCategoriaTraerSuccess = (payload) => {
  return {
    type: types.configuracionPorCategoriaTraerSuccess,
    payload: payload,
  };
};
export const configuracionCategoriaLimpiar = () => ({ type: types.configuracionCategoriaLimpiar });

export const traerConfiguracionPorCategoria = (id) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    dispatch(configuracionPorCategoriaTraerStart());
    const response = await fetchConToken(
      `TipoAfiliacionCategoria/traerPorIdCategoria/${id}`
    );
    if (!response.ok) {
      dispatch(configuracionPorCategoriaTraerError(response.statusText));
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const respuesta = await response.json();
      if (respuesta.length > 0) {
        dispatch(configuracionPorCategoriaTraerSuccess(respuesta));
      }
    }
    dispatch(finishSpinner());
  };
};

export const traerConfiguracionPorCategoriaAutogestion = (id) => {
  return async (dispatch,getState) => {
    dispatch(configuracionPorCategoriaTraerStart());
    const state = getState();
    const {usuarioAutogestion} =  state.userAutogestion;
    fetch(`${urlBase}/api/TipoAfiliacionCategoria/traerPorIdCategoria/${id}`,{headers: {'Content-Type': 'application/json','Authorization':'Bearer '+usuarioAutogestion.token}})
    .then(res=>res.json())
    .then(res=>{
      if (res.status!==401) {
        dispatch(configuracionPorCategoriaTraerSuccess(res));     
      }else{
        
      }
    })
  };
};

export const deleteEstadoMarcadoCategoria = (idCategoria,idTipoAfiliacion) => async (dispatch) => {
  const response = await fetchConToken(
    `TipoAfiliacionCategoria/${idTipoAfiliacion}/${idCategoria}`,
    '',
    "DELETE"
  );
  if (!response.ok) {
    //TODO Dispatch de error y actualizacion reducer de error
    throw Error(response.statusText);
  }
        dispatch({
        type: "deletePrueba",
       // payload: id
      });
      dispatch(traerConfiguracionPorCategoria(idCategoria));
}

export const nuevoEstadoMarcadoCategoria = (data) => async (dispatch) => {
  const response = await fetchConToken(
    `TipoAfiliacionCategoria`,
    data,
    "POST"
  );
  if (!response.ok) {
    //TODO Dispatch de error y actualizacion reducer de error
    throw Error(response.statusText);
  }
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.indexOf("application/json") !== -1) {
      // const res = await response.json();
      dispatch({
        type: 'prue4',
       // payload: res,
      });
      dispatch(traerConfiguracionPorCategoria(data.idCategoria));
  } else {
      //TODO Dispatch de error y actualizacion reducer de error
    throw new Error(response);
  }
}

